import {
    AfterContentInit, Component, ContentChild,
    ContentChildren, EventEmitter, Input,
    OnChanges, OnInit, Output, QueryList, ViewChild, AfterViewInit
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort} from '@angular/material/sort';
import { MatColumnDef, MatHeaderRowDef, MatRowDef, MatTable } from '@angular/material/table';
import { DataSource } from '@angular/cdk/collections';
import { DataColumnComponent } from './data-column.component';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-data-table',
    templateUrl: './data-table.component.html',
    styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent<T> implements OnInit, OnChanges, AfterContentInit, AfterViewInit {

    @ContentChildren(DataColumnComponent) dynColumns: QueryList<DataColumnComponent<T>>;
    @ContentChildren(MatColumnDef) columnDefs: QueryList<MatColumnDef>;

    @ContentChild(MatHeaderRowDef, { static: true }) headerRowDef: MatHeaderRowDef;
    @ContentChildren(MatRowDef) rowDefs: QueryList<MatRowDef<T>>;

    @ViewChild(MatPaginator ,{static: true}) paginator: MatPaginator;
    @ContentChild(MatSort ,{static: true}) sort: MatSort;

    @ViewChild(MatTable ,{static: true}) table: MatTable<T>;

    @Input()
    public displayedColumns: string[];

    @Input()
    public dataSource: DataSource<T>;

    @Input()
    noResultMessage = 'No results found';

    @Input()
    defaultPageSize = 10;

    selectedRowIndex = 0;
    @Input()
    selectedRow: T;

    @Output()
    public refresher: EventEmitter<any> = new EventEmitter<any>();

    constructor() {

    }

    getSort(): MatSort {
        return this.sort;
    }

    getPaginator(): MatPaginator {
        return this.paginator;
    }

    ngOnChanges() { }

    ngAfterContentInit() {
        this.dynColumns.forEach(dynColumn => this.table.addColumnDef(dynColumn.columnDef));
        this.columnDefs.forEach(columnDef => this.table.addColumnDef(columnDef));
    }

    ngOnInit() {

    }

    ngAfterViewInit() {
        this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
        merge(this.sort.sortChange, this.paginator.page)
            .pipe(
                tap(() => this.refresher.emit({
                    sort: this.sort,
                    paginator: this.paginator
                }))
            ).subscribe();
    }

    selectRow(row: T, index) {
        this.selectedRowIndex = index;
        this.selectedRow = row;
    }

}
